import React, { useEffect, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";

import BookSidebar from "../components/Book/BookSidebar";
import MarkdownRenderer from "../components/Book/MarkdownRenderer";
import styles from "../components/Book/Book.module.css";

// ✅ IMPORTA TU MANIFEST REAL
import tokenBookManifest from "../data/books/token-book/manifest.json";

// Si luego agregas más libros, los agregas aquí:
const BOOKS = {
  "token-book": tokenBookManifest,
};

function flatten(manifest) {
  const out = [];
  (manifest?.sections || []).forEach((sec) => {
    (sec.items || []).forEach((it) => out.push(it));
  });
  return out;
}

export default function BookPage() {
  const { bookId, slug } = useParams();
  const navigate = useNavigate();

  const manifest = BOOKS[bookId] || tokenBookManifest;
  const flat = useMemo(() => flatten(manifest), [manifest]);

  const currentIndex = useMemo(() => {
    const wanted = slug || flat?.[0]?.slug;
    const idx = flat.findIndex((x) => x.slug === wanted);
    return idx >= 0 ? idx : 0;
  }, [flat, slug]);

  const current = flat[currentIndex] || flat[0];
  const prev = flat[currentIndex - 1] || null;
  const next = flat[currentIndex + 1] || null;

  // ✅ Si entras a /course/:bookId sin slug, redirige al primero
  useEffect(() => {
    if (!slug && current?.slug) {
      navigate(`/course/${manifest.id}/${current.slug}`, { replace: true });
    }
  }, [slug, current?.slug, manifest.id, navigate]);

  // ✅ Guardas para evitar undefined/undefined
  if (!manifest?.basePath) {
    return (
      <div style={{ padding: 20 }}>
        Error: tu manifest no tiene <b>basePath</b>. Revisa:
        <pre style={{ marginTop: 10 }}>
          src/frontend/data/books/{manifest?.id || "token-book"}/manifest.json
        </pre>
      </div>
    );
  }

  if (!current?.file) {
    return (
      <div style={{ padding: 20 }}>
        Error: el capítulo actual no tiene <b>file</b>. Revisa tu manifest en la sección/items.
      </div>
    );
  }

  return (
    <div className={styles.layout}>
      <BookSidebar
        manifest={manifest}
        currentSlug={current?.slug}
        baseRoute="/course"
      />

      <main className={styles.main}>
        <div className={styles.topBar}>
          <div className={styles.breadcrumb}>
            {manifest.title} · {current?.title}
          </div>

          <div className={styles.navBtns}>
            <button
              className={styles.btn}
              disabled={!prev}
              onClick={() => prev && navigate(`/course/${manifest.id}/${prev.slug}`)}
            >
              ← Anterior
            </button>

            <button
              className={styles.btnPrimary}
              disabled={!next}
              onClick={() => next && navigate(`/course/${manifest.id}/${next.slug}`)}
            >
              Siguiente →
            </button>
          </div>
        </div>

        <div className={styles.content}>
          {/* ✅ PASA basePath y file, NO url */}
          <MarkdownRenderer basePath={manifest.basePath} file={current.file} />
        </div>
      </main>
    </div>
  );
}
